import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import visaIcon from '../../images/icons/visa.svg';
import mastercardIcon from '../../images/icons/mastercard.svg';
import amexIcon from '../../images/icons/amex.svg';
import discoverIcon from '../../images/icons/discover.svg';
import playbillLogo from '../../images/logo-playbill.gif';
import mtiLogo from '../../images/logo-mti.gif';
import etaLogo from '../../images/logo-eta.gif';
import './Footer.css';
import PropTypes from "prop-types";

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInStreamPage: false
        };
    }

    componentDidMount() {
        this.checkPath();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.checkPath();
        }
    }

    checkPath = () => {
        const isInStreamPage = this.props.location.pathname.indexOf('/stream') !== -1;
        this.setState({
            isInStreamPage
        });
    };

    openCalendly = () => {
        window.Calendly.showPopupWidget('https://calendly.com/showtix4u');
        // Accessibility - Add focus on iframe when opening Calendly
		let calendlyIframe = document.querySelectorAll('.calendly-popup iframe')[0];
		setTimeout(() => {
			calendlyIframe.setAttribute('title', 'Showtix Support');
			calendlyIframe.setAttribute('tabIndex', -1);
			calendlyIframe.focus();
		}, 1000);
    };

    render() {
        return (
            <footer className="showtix-footer" id="footer">
                <p className="showtix-footer__text showtix-footer__requirements">{strings.requirements}</p>

                { (this.state.isInStreamPage) ?
                <div className="showtix-footer__logos showtix-footer__logos--partners">
                    <a href="https://www.playbill.com/" target="_blank" rel="noopener noreferrer" aria-label="Select to go to Playbill website">
                        <i className="showtix-footer__logo" role="img" aria-label="Playbill logo" style={{backgroundImage: "url(" + playbillLogo + ")"}}></i>
                    </a>
                    <a href="https://www.mtishows.com/" target="_blank" rel="noopener noreferrer" aria-label="Select to go to MTI Shows website">
                        <i className="showtix-footer__logo" role="img" aria-label="MTI logo" style={{backgroundImage: "url(" + mtiLogo + ")"}}></i>
                    </a>
                    <a href="https://www.schooltheatre.org/home" target="_blank" rel="noopener noreferrer" aria-label="Select to go to School Theatre website">
                        <i className="showtix-footer__logo" role="img" aria-label="ETA logo" style={{backgroundImage: "url(" + etaLogo + ")"}}></i>
                    </a>
                </div>
                :
                <div className="showtix-footer__logos">
                    <span className="sr-only">We support those credit cards:</span>
                    <i className="showtix-footer__logo" role="img" aria-label="Visa Credit Card logo" style={{backgroundImage: "url(" + visaIcon + ")"}}></i>
                    <i className="showtix-footer__logo" role="img" aria-label="Mastercard Credit Card logo" style={{backgroundImage: "url(" + mastercardIcon + ")"}}></i>
                    <i className="showtix-footer__logo" role="img" aria-label="Amex Credit Card logo" style={{backgroundImage: "url(" + amexIcon + ")"}}></i>
                    <i className="showtix-footer__logo" role="img" aria-label="Discover Credit Card logo" style={{backgroundImage: "url(" + discoverIcon + ")"}}></i>
                </div>
                }


                <ul className="showtix-footer__linksList">
                {
                    strings.links.map((link, i) => {
                        return <li className="showtix-footer__linkItem" key={i}>
                            {link.calendly ? (
                                <button
                                    onClick={() => this.openCalendly()}
                                    className={"showtix-footer__link"}
                                    >{link.text}</button>
                            ) : (
                                link.external ? (
                                    <a href={link.url}
                                        className={"showtix-footer__link"}
                                        target="_blank" rel="noopener">{link.text}</a>
                                ) : (
                                    <Link to={link.url} className="showtix-footer__link">{link.text}</Link>
                                )
                            )}
                        </li>;
                    })
                }
                </ul>

                <p className="showtix-footer__text showtix-footer__legal">{strings.legalPrefix} {(new Date().getFullYear())} {strings.legalSuffix}</p>
            </footer>
        )
    }
}
 
export default withRouter(Footer);

Footer.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string
    }).isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js